import { type AxiosRequestConfig, type AxiosResponse } from 'axios';

import ServiceError from './serviceError';

interface IApiErrorMeta {
  request: {
    baseURL?: string;
    url?: string;
    method?: string;
    params?: AxiosRequestConfig['params'];
    data?: AxiosRequestConfig['data'];
    headers?: AxiosRequestConfig['headers'];
  };
  response: {
    status: number;
    data?: any;
  };
  err: any;
}

export default class ApiError extends ServiceError<IApiErrorMeta> {
  public readonly status: number;
  public readonly data: any;

  constructor(request: AxiosRequestConfig, axiosResponse?: AxiosResponse, err: any = {}) {
    const response = axiosResponse
      ? { status: axiosResponse.status, data: axiosResponse.data }
      : { status: -1, data: null };

    const safeErr = { ...err };
    delete safeErr.request;
    delete safeErr.response;
    delete safeErr.config;

    const message = response.data?.message || err.message || 'api-error';
    const retryable = response.status >= 500 || response.status === -1;

    super(message, { request, response, err: safeErr }, retryable);

    this.status = response.status;
    this.data = response.data;
  }
}
